<template>
  <div
    ref="registrationFormSteps"
    class="registration-steps"
  >
    <transition
      name="step"
      mode="out-in"
      @before-leave="onBeforeLeave"
      @before-enter="onBeforeEnter"
      @after-enter="onAfterEnter"
    >
      <registration-step-contact-data
        v-if="currentStep === 1"
        key="step-1"
        @valid-changed="(value) => $emit('valid-changed-step-contact-data', value)"
      />
      <registration-step-address
        v-else-if="currentStep === 2"
        key="step-2"
        @valid-changed="(value) => $emit('valid-changed-step-address', value)"
      />
      <registration-step-password
        v-else-if="currentStep === 3"
        key="step-3"
        @valid-changed="(value) => $emit('valid-changed-step-password', value)"
      />
    </transition>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef, watch } from 'vue';

import RegistrationStepAddress from '@/components/registration/fischer/registration-steps/RegistrationStepAddress.vue';
import RegistrationStepContactData from '@/components/registration/fischer/registration-steps/RegistrationStepContactData.vue';
import RegistrationStepPassword from '@/components/registration/fischer/registration-steps/RegistrationStepPassword.vue';
import { useRegistrationSteps } from '@/composables/registrationSteps';

defineOptions({ name: 'RegistrationWithoutTargetGroup' });

interface Props {
  currentStep?: number;
}

const props = withDefaults(defineProps<Props>(), {
  currentStep: 1,
});

const emit = defineEmits<{
  'step-type-changed': [stepType: string];
  'valid-changed-step-address': [value: boolean];
  'valid-changed-step-contact-data': [value: boolean];
  'valid-changed-step-password': [value: boolean];
}>();

const registrationFormSteps = useTemplateRef<HTMLElement>('registrationFormSteps');
const { onBeforeLeave, onBeforeEnter, onAfterEnter } = useRegistrationSteps(registrationFormSteps);

watch(
  () => props.currentStep,
  (newVal) => {
    let stepType = '';

    switch (newVal) {
      case 1:
        stepType = 'contact-data';
        break;
      case 2:
        stepType = 'address';
        break;
      case 3:
        stepType = 'password';
        break;
      default:
        stepType = '';
        break;
    }

    emit('step-type-changed', stepType);
  },
);
</script>

<style src="./registration-steps" />
